import { useEffect, useState } from 'react';
import LoadImage from '../../../commons/LoadImage';
import { Stage, Layer, Group, Rect, Line, Text } from 'react-konva';
import { handleStageWheel, cursorGrab, handleStageDragStart, renderPcs, handleStageDragMoveFukida } from '../../../utils/DiagramParts';
import { getDeviceConfig, getElectricityInfo } from '../../../api/api';
import Spinner from '../../../commons/Spinner';
import { formatPower } from '../../../utils/NumberUtils';

const HatazawaElec = ({ setSelected, setDeviceArr, goToInfo, deviceId }) => {
    const transfomer = ['TR 1Φ3W\n\n100kVA\n\n6.6KV/210V-105V', 'TR3Φ3W\n\n75kVA\n\n6.6kV/210V']
    const stageScale = 1;
    const [isLoading, setIsLoading] = useState(true);
    const authToken = localStorage.getItem('accessToken');
    const [scene, setScene] = useState({ width: window.innerWidth, height: window.innerHeight - 150 });
    const [deviceList, setDeviceList] = useState({
        batArr: [
            {
                device_id: 'BTPCS1',
                // device_id: 'BTPCS1'
            },
            {
                device_id: 'BTPCS2',
                // device_id: 'BTPCS2'
            },
            {
                device_id: 'BTPCS3',
                // device_id: 'BTPCS3'
            },
            {
                device_id: 'BTPCS4',
                // device_id: 'BTPCS4'
            },
            {
                device_id: 'BTPCS5',
                // device_id: 'BTPCS5'
            },
            {
                device_id: 'BTPCS6',
                // device_id: 'BTPCS6'
            },
            {
                device_id: 'BTPCS7',
                // device_id: 'BTPCS7'
            },
            {
                device_id: 'BTPCS8',
                // device_id: 'BTPCS8'
            },
            {
                device_id: 'BTPCS9',
                // device_id: 'BTPCS9'
            },
            {
                device_id: 'BTPCS10',
                // device_id: 'BTPCS10'
            },
            {
                device_id: 'BTPCS11',
                // device_id: 'BTPCS11'
            },
            {
                device_id: 'BTPCS12',
                // device_id: 'BTPCS12'
            }
        ],
        pcsArr: [
            {
                device_id: 'PVPCS1',
                // device_id: 'PVPCS1'
            },
            {
                device_id: 'PVPCS2',
                // device_id: 'PVPCS2'
            },
            {
                device_id: 'PVPCS3',
                // device_id: 'PVPCS3'
            },
            {
                device_id: 'PVPCS4',
                // device_id: 'PVPCS4'
            },
            {
                device_id: 'PVPCS5',
                // device_id: 'PVPCS5'
            },
            {
                device_id: 'PVPCS6',
                // device_id: 'PVPCS6'
            },
            {
                device_id: 'PVPCS7',
                // device_id: 'PVPCS7'
            },
            {
                device_id: 'PVPCS8',
                // device_id: 'PVPCS8'
            },
            {
                device_id: 'PVPCS9',
                // device_id: 'PVPCS9'
            },
            {
                device_id: 'PVPCS10',
                // device_id: 'PVPCS10'
            },
            {
                device_id: 'PVPCS11',
                // device_id: 'PVPCS11'
            },
            {
                device_id: 'PVPCS12',
                // device_id: 'PVPCS12'
            }
        ],
        hybridPcs: [{
            device_id: 'PV_50KW_PCS_1',
            // device_id: 'PV_50KW_PCS_1'
        }],
        multiMeter: [{
            // device_id: 'マルチメタ_1',
            device_id: 'METER_1',
            device_maker_type: 'Janitza'
        }],
        sumGenerating: 0,
        rs_line_volt: 0,
        st_line_volt: 0,
        tr_line_volt: 0,
        real_power: 0
    });

    useEffect(() => {
        if (deviceId !== null) {
            const controller = new AbortController();
            const signal = controller.signal;
            const fetchDevices = async (signal) => {
                setIsLoading(true);
                // Promise.all([
                let deviceDataDefault = deviceList;
                let multimeterDefault = {
                    sum_generating: 0,
                    rs_line_volt: 0,
                    st_line_volt: 0,
                    tr_line_volt: 0,
                    real_power: 0
                };
                let multimeterData = null;

                const deviceDataFetched = await getDeviceConfig(authToken, deviceId, { configType: 'network_config' }, signal);

                if (deviceDataFetched.length > 0) {
                    const hybridPcs = deviceDataFetched.filter(el => el.device_id.toLowerCase().includes('50'));
                    const multiMeter = deviceDataFetched.filter(el => el.device_maker_type.toLowerCase().includes('janitza'));
                    const batArr = deviceDataFetched.filter(el => el.device_id.toLowerCase().startsWith('btpcs')
                    ).sort((a, b) => a.device_id.localeCompare(b.device_id, 'en', { numeric: 'true', sensitivity: 'base' }));

                    const pcsArr = deviceDataFetched.filter(el => el.device_id.toLowerCase().startsWith('pvpcs')
                    ).sort((a, b) => a.device_id.localeCompare(b.device_id, 'en', { numeric: 'true', sensitivity: 'base' }));
                    setScene({ width: window.innerWidth, height: window.innerHeight + batArr.length * 270 });
                    // setDeviceList({ ...deviceList, hybridPcs, multiMeter, batArr, pcsArr });
                    deviceDataDefault = { hybridPcs, multiMeter, batArr, pcsArr };
                    multimeterData = multiMeter;
                    setDeviceArr([...hybridPcs, ...multiMeter, ...batArr, ...pcsArr]);
                }

                if (multimeterData !== null) {
                    const multiMeterFetched = await getElectricityInfo(authToken, deviceId, { ...multimeterData[0] }, signal);
                    if (multiMeterFetched !== null) {
                        multimeterDefault = multiMeterFetched;
                    }
                }

                setDeviceList({ ...deviceDataDefault, ...multimeterDefault });
                setIsLoading(false);
            };
            fetchDevices(signal);
            return () => {
                controller.abort();
            };
        }//eslint-disable-next-line
    }, [deviceId]);

    const cursorPoint = (e) => {
        const container = e.target.getStage().container();
        container.style.cursor = 'pointer';
    };

    const cursorNormal = (e) => {
        const container = e.target.getStage().container();
        container.style.cursor = 'default';
    };

    const getCurrentBoxLine = (n) => {
        const x = 80;
        let y = 110;

        if (n === 1) {
            return <Line stroke="black" points={[0, 170, 0, 80, 170, 80, 170, 100]} />
        } else {
            const val = [<Line stroke="black" points={[0, 170, 0, 80, 80, 80, 80, 100, 80, 110, 100, 110]} />];

            for (let i = 0; i < n - 1; i++) {
                val.push(<Line stroke="black" points={[x, y, x, y + 270, x + 20, y + 270, x, y + 270, x + 20, y + 270]} />);
                y += 270;
            }
            return val;
        }
    };


    return (
        <>{
            isLoading ? <Spinner /> :
                <Stage
                    id="fukida"
                    width={scene.width}
                    height={scene.height}
                    scaleX={+stageScale}
                    scaleY={+stageScale}
                    onWheel={handleStageWheel}
                    draggable={true}
                    onDragStart={handleStageDragStart}
                    onDragEnd={cursorGrab}
                    onMouseOver={cursorGrab}
                    onDragMove={handleStageDragMoveFukida}
                >
                    <Layer>
                        {renderPcs([deviceList.batArr[0], deviceList.pcsArr[0], deviceList.batArr[1], deviceList.pcsArr[1], deviceList.batArr[2], deviceList.pcsArr[2]], 160, 280, setSelected, goToInfo, deviceList.pcsArr.length)}
                        {renderPcs([deviceList.batArr[3], deviceList.pcsArr[3], deviceList.batArr[4], deviceList.pcsArr[4], deviceList.batArr[5], deviceList.pcsArr[5]], 160, 545, setSelected, goToInfo, deviceList.pcsArr.length)}
                        {renderPcs([deviceList.batArr[6], deviceList.pcsArr[6], deviceList.batArr[7], deviceList.pcsArr[7], deviceList.batArr[8], deviceList.pcsArr[8], deviceList.batArr[9], deviceList.pcsArr[9]], 160, 815, setSelected, goToInfo, deviceList.pcsArr.length)}

                        {/* Top button */}
                        <Group x={0} y={0}>
                            <Rect width={120} height={30} stroke="#000000" fill="#99ffcc" strokeWidth={1} />
                            <Text text="地絡過電圧OVGR" padding={10} fontVariant="bold" fontSize={13} />
                        </Group>
                        {/* Main line */}
                        <Group x={240} y={0}>
                            {/* Button */}
                            <Rect width={45} height={30} stroke="#000000" fill="#fff" strokeWidth={1} cornerRadius={4} />
                            <Text
                                text="系統"
                                padding={9}
                                fontVariant="bold"
                                fontSize={13}
                            // onClick={(e) => setSelected('sm')}
                            // onClick={(e) => setDeviceLength(deviceLength + 1)}
                            // onMouseEnter={cursorPoint}
                            // onMouseLeave={cursorNormal}
                            />
                            <Line stroke="black" points={[45 / 2, 30, 45 / 2, 100]} />
                            <Text
                                text={deviceList.multiMeter[0]?.device_id.toString()}
                                fontVariant="bold"
                                fontSize={13}
                                x={-35}
                                y={120}
                                fill="blue"
                                textDecoration="underline"
                                onClick={(e) => setSelected(deviceList.multiMeter[0])}
                                onMouseEnter={cursorPoint}
                                onMouseLeave={cursorNormal}
                            />
                            <Rect x={0} y={100} width={40} height={55} strokeWidth={1} stroke="black" fill="red" />
                            <LoadImage src="/img/vcb.png" x={3} y={100} height={100 / 1.80} width={46 / 1.80} />
                            <Line stroke="black" points={[45 / 2, 155, 45 / 2, 180]} />
                        </Group>

                        {/* Table */}
                        <Group x={350} y={10}>
                            {/* Title */}
                            <Text text="系統電圧・電力" fontVariant="bold" padding={9} offsetX={5} />

                            <Rect width={150} height={80} stroke="#000000" fill="#fff" strokeWidth={1} x={0} y={25} />
                            {/* Inner Lines */}
                            {Array(3)
                                .fill()
                                .map((el, i) => (
                                    <Line
                                        x={0}
                                        y={25}
                                        points={[0, (i + 1) * 20, 150, (i + 1) * 20]}
                                        stroke="#00000"
                                        strokeWidth={1}
                                        key={i}
                                    />
                                ))}
                            {/* Data */}
                            {[deviceList.rs_line_volt, deviceList.st_line_volt, deviceList.tr_line_volt, deviceList.real_power].map((el, i) => (
                                <Text x={20} y={25 + i * 20} text={(i <= 2) ? !el ? "---V" : !el ? "---W" : Number(el).toFixed(2) + 'V' : (formatPower(el, 2))} padding={4} key={i} />
                            ))}
                        </Group>
                        {/* Left and right group */}
                        <Group x={0} y={180}>
                            {/* Left Side */}
                            <Group x={60} y={0}>
                                <LoadImage src="/img/left.svg" height={80} width={80} x={-1} y={0} />
                                {/* Left Text */}
                                <Text text={transfomer[0]} x={70} y={20} lineHeight={0.675} />
                                {/* m */}
                                {getCurrentBoxLine(3)}
                                <Rect width={45} height={30} x={-20} y={170} stroke="#000000" strokeWidth={1} fill="#fff" />
                                <Text
                                    text="負荷"
                                    x={-20}
                                    y={170}
                                    padding={10}
                                    fontVariant="bold"
                                />
                            </Group>

                            {/* Bridge */}
                            {/* Bridge Line */}
                            {/* SumGenerating */}
                            <Line stroke="black" points={[100, 0, 1200, 0]} />
                            {/* <Group x={280} y={20}>
                        <Text x={0} y={0} text={'再エネ発電電力'} fill="black" fontStyle="bold" fontSize={13} padding={10} />
                        <Rect x={10} y={30} width={140} height={20} stroke="#000000" strokeWidth={1} />
                        <Text x={25} y={30} text={isNaN(deviceList.sumGenerating) ? '0kWh' : deviceList.sumGenerating.toFixed(2) + 'kWh'} fill="black" fontStyle="bold" padding={5} />
                    </Group> */}

                            {/* Right */}
                            <Group x={1150} y={0}>
                                <LoadImage src="/img/right.svg" height={80} width={80} x={10} y={0} />
                                <Text text={transfomer[1]} x={80} y={20} lineHeight={0.675} />
                                <Line points={[0, 170, 0, 80, 100, 80, 100, 170]} stroke="black" />
                                <Group x={-20} y={170}>
                                    <Rect width={45} height={30} stroke="#000000" strokeWidth={1} fill="#fff" />
                                    <Text
                                        text="負荷"
                                        padding={10}
                                        fontVariant="bold"
                                    />
                                </Group>

                                {/* hybridPcs */}
                                <Group x={80} y={170}>
                                    <LoadImage src="/img/battery.png" height={28} width={40} fill="lightgreen" />
                                    <Text
                                        x={0}
                                        y={40}
                                        text={deviceList.hybridPcs[0]?.device_id.toString()}
                                        lineHeight={0.675}
                                        fill="blue"
                                        textDecoration="underline"
                                        onClick={(e) => setSelected(deviceList.hybridPcs[0])}
                                        onMouseEnter={cursorPoint}
                                        onMouseLeave={cursorNormal}
                                    />
                                </Group>
                            </Group>
                        </Group>
                    </Layer>
                </Stage>
        }
        </>
    );
};

export default HatazawaElec;

